import Swiper, { Navigation } from 'swiper'; Swiper.use(Navigation);

export function init() {

	// Product image - rear view and customisation ---------------------------------------------------- //

	const toggleRearView = () => {
		document.querySelector('.product-image').classList.toggle('-showrear');
		document.querySelector('.toggle-rear-view').classList.toggle('-showrear');
	}

	if (document.querySelector('.toggle-rear-view')) {
		document.querySelector('.toggle-rear-view').addEventListener('click', (e) => {
			e.preventDefault();
			toggleRearView();
		});
	}

	if (document.querySelector('.module-productinfo .product-image-controls .finish')) {

		const finishButtons = document.querySelectorAll('.module-productinfo .product-image-controls .finish li, .module-productinfo .product-image-controls .metalwork li, .module-productinfo .product-image-controls .finish .swiper-slide');

		finishButtons.forEach((el) => {

			el.addEventListener('mouseover', (e) => {

				if (e.target.getAttribute('data-finishid')) { // it's a finish

					const finishId = e.target.dataset.finishid;

					// lazy load if applicable
					if (!document.querySelector('.module-productinfo .finishes img[data-finishid="' + finishId + '"]').getAttribute('src')) {
						const imgSrc = document.querySelector('.module-productinfo .finishes img[data-finishid="' + finishId + '"]').dataset.src;
						document.querySelector('.module-productinfo .finishes img[data-finishid="' + finishId + '"]').setAttribute('src', imgSrc);
					}

				} else if (e.target.getAttribute('data-metalworkid')) { // it's metalwork

					const metalworkId = e.target.dataset.metalworkid;

					// lazy load if applicable
					if (!document.querySelector('.module-productinfo .metalwork img[data-metalworkid="' + metalworkId + '"]').getAttribute('src')) {
						const imgSrc = document.querySelector('.module-productinfo .metalwork img[data-metalworkid="' + metalworkId + '"]').dataset.src;
						document.querySelector('.module-productinfo .metalwork img[data-metalworkid="' + metalworkId + '"]').setAttribute('src', imgSrc);
					}

				}

			});

			el.addEventListener('click', (e) => {

				if (document.querySelector('.module-productinfo .product-image').classList.contains('-showrear')) {
					toggleRearView();
				}

				if (e.target.getAttribute('data-finishid')) { // it's a finish

					const finishId = e.target.dataset.finishid;

					// lazy load if applicable
					if (!document.querySelector('.module-productinfo .finishes img[data-finishid="' + finishId + '"]').getAttribute('src')) {
						const imgSrc = document.querySelector('.module-productinfo .finishes img[data-finishid="' + finishId + '"]').dataset.src;
						document.querySelector('.module-productinfo .finishes img[data-finishid="' + finishId + '"]').setAttribute('src', imgSrc);
					}

					// hide other finishes and show the selected one
					const allFinishes = document.querySelectorAll('.module-productinfo .finishes img');
					allFinishes.forEach((el) => { el.classList.remove('-visible'); });
					document.querySelector('.module-productinfo .finishes img[data-finishid="' + finishId + '"]').classList.add('-visible');

					if (document.querySelector('.module-productinfo .rear img')) {
						const allRearFinishes = document.querySelectorAll('.module-productinfo .rear img');
						allRearFinishes.forEach((el) => { el.classList.remove('-visible'); });
						document.querySelector('.module-productinfo .rear img[data-finishid="' + finishId + '"]').classList.add('-visible');
					}

					// select the active finish control
					const allFinishControls = document.querySelectorAll('.module-productinfo .product-image-controls .finish li, .module-productinfo .product-image-controls .finish .swiper-slide');
					allFinishControls.forEach((el) => { el.classList.remove('-active'); });
					e.target.classList.add('-active');

					// update the finish label
					if (e.target.getAttribute('data-finishname')) {
						const finishName = e.target.dataset.finishname;
						const finishGroup = e.target.dataset.finishgroup;
						if (document.querySelector('.module-productinfo .product-image .colour-name')) {
							document.querySelector('.module-productinfo .product-image .colour-name').innerText = finishName;
						} else {
							document.querySelector('.module-productinfo .product-image-controls .finish-name strong').innerText = finishName;
							if (document.querySelector('.module-productinfo .product-image-controls .finish-name span')) {
								document.querySelector('.module-productinfo .product-image-controls .finish-name span').innerText = finishGroup;
							}
						}
					}

				} else if (e.target.getAttribute('data-metalworkid')) { // it's metalwork

					const metalworkId = e.target.dataset.metalworkid;

					// lazy load if applicable
					if (!document.querySelector('.module-productinfo .metalwork img[data-metalworkid="' + metalworkId + '"]').getAttribute('src')) {
						const imgSrc = document.querySelector('.module-productinfo .metalwork img[data-metalworkid="' + metalworkId + '"]').dataset.src;
						document.querySelector('.module-productinfo .metalwork img[data-metalworkid="' + metalworkId + '"]').setAttribute('src', imgSrc);
					}

					// hide other finishes and show the selected one
					const allFinishes = document.querySelectorAll('.module-productinfo .metalwork img');
					allFinishes.forEach((el) => { el.classList.remove('-visible'); });
					document.querySelector('.module-productinfo .metalwork img[data-metalworkid="' + metalworkId + '"]').classList.add('-visible');

					// select the active finish control
					const allFinishControls = document.querySelectorAll('.module-productinfo .product-image-controls .metalwork li');
					allFinishControls.forEach((el) => { el.classList.remove('-active'); });
					e.target.classList.add('-active');

				}

			});
		});

		const customisationSlider = new Swiper('.module-productinfo .finish .swiper-container', {
			slidesPerView: 'auto',
			freeMode: true,
			speed: 700,
			spaceBetween: 5,
			navigation: {
				nextEl: '.module-productinfo .slide-right',
				prevEl: '.module-productinfo .slide-left'
			},
		});

		const customisationSliderModule = document.querySelector('.module-productinfo .finish .swiper-container');

		customisationSlider.on('progress', () => {
			if (customisationSlider.isEnd && customisationSlider.isBeginning) {
				customisationSliderModule.classList.remove('-rightfade', '-leftfade');
				customisationSliderModule.querySelector('.slide-right').classList.remove('-visible');
				customisationSliderModule.querySelector('.slide-left').classList.remove('-visible');
			} else if (customisationSlider.isEnd) {
				customisationSliderModule.classList.remove('-rightfade');
				customisationSliderModule.classList.add('-leftfade');
				customisationSliderModule.querySelector('.slide-right').classList.remove('-visible');
				customisationSliderModule.querySelector('.slide-left').classList.add('-visible');
			} else if (customisationSlider.isBeginning) {
				customisationSliderModule.classList.remove('-leftfade');
				customisationSliderModule.classList.add('-rightfade');
				customisationSliderModule.querySelector('.slide-left').classList.remove('-visible');
				customisationSliderModule.querySelector('.slide-right').classList.add('-visible');
			} else {
				customisationSliderModule.classList.add('-leftfade', '-rightfade');
				customisationSliderModule.querySelector('.slide-right').classList.add('-visible');
				customisationSliderModule.querySelector('.slide-left').classList.add('-visible');
			}
		});

	}

	// LP12 Customisation ----------------------------------------------------------------------------- //

	if (document.querySelector('.module-lp12customiser')) {

		document.querySelector('.module-lp12customiser form').addEventListener('submit', (e) => {
			e.preventDefault();
		});

		if (document.querySelector('.module-lp12customiser input#monogram')) {
			document.querySelector('.module-lp12customiser input#monogram').addEventListener('keydown', (e) => {
				setTimeout(() => {
					const contents = document.querySelector('.module-lp12customiser input#monogram').value;
					document.querySelector('.monogram2').innerText = contents;
				}, 1);
			});
		}

		if (document.querySelector('.-printlp12')) {
			document.querySelector('.-printlp12').addEventListener('click', (e) => {
				e.preventDefault();
				window.print();
			});
		}

		// LP12 Customisation
		const finishButtons2 = document.querySelectorAll('.module-lp12customiser .product-image-controls .finish li, .module-lp12customiser .product-image-controls .finish .swiper-slide');

		finishButtons2.forEach((el) => {

			el.addEventListener('mouseover', (e) => {

				const finishId2 = e.target.dataset.finishid;

				// lazy load if applicable
				if (!document.querySelector('.module-lp12customiser .finishes img[data-finishid="' + finishId2 + '"]').getAttribute('src')) {
					const imgSrc = document.querySelector('.module-lp12customiser .finishes img[data-finishid="' + finishId2 + '"]').dataset.src;
					document.querySelector('.module-lp12customiser .finishes img[data-finishid="' + finishId2 + '"]').setAttribute('src', imgSrc);
				}

			});

			el.addEventListener('click', (e) => {

				const finishId2 = e.target.dataset.finishid;

				// lazy load if applicable
				if (!document.querySelector('.module-lp12customiser .finishes img[data-finishid="' + finishId2 + '"]').getAttribute('src')) {
					const imgSrc = document.querySelector('.module-lp12customiser .finishes img[data-finishid="' + finishId2 + '"]').dataset.src;
					document.querySelector('.module-lp12customiser .finishes img[data-finishid="' + finishId2 + '"]').setAttribute('src', imgSrc);
				}

				// hide other finishes and show the selected one
				const allFinishes2 = document.querySelectorAll('.module-lp12customiser .finishes img');
				allFinishes2.forEach((el) => { el.classList.remove('-visible'); });
				document.querySelector('.module-lp12customiser .finishes img[data-finishid="' + finishId2 + '"]').classList.add('-visible');

				// select the active finish control
				const allFinishControls2 = document.querySelectorAll('.module-lp12customiser .product-image-controls .finish li, .module-lp12customiser .product-image-controls .finish .swiper-slide');
				allFinishControls2.forEach((el) => { el.classList.remove('-active'); });
				e.target.classList.add('-active');

				// update the finish label
				if (e.target.getAttribute('data-finishname')) {
					const finishName2 = e.target.dataset.finishname;
					const finishGroup2 = e.target.dataset.finishgroup;
					if (document.querySelector('.module-lp12customiser .product-image .colour-name')) {
						document.querySelector('.module-lp12customiser .product-image .colour-name').innerText = finishName2;
					} else {
						document.querySelector('.module-lp12customiser .product-image-controls .finish-name strong').innerText = finishName2;
						document.querySelector('.module-lp12customiser .product-image-controls .finish-name span').innerText = finishGroup2;
					}
				}

			});
		});

		const productSlider = document.querySelector('.module-lp12customiser .finish .swiper-container');

		const customisationSlider2 = new Swiper('.module-lp12customiser .finish .swiper-container', {
			slidesPerView: 'auto',
			freeMode: true,
			speed: 700,
			spaceBetween: 5,
			navigation: {
				nextEl: '.module-lp12customiser .slide-right',
				prevEl: '.module-lp12customiser .slide-left'
			},
		});

		customisationSlider2.on('progress', () => {
			if (customisationSlider2.isEnd && customisationSlider2.isBeginning) {
				productSlider.classList.remove('-rightfade', '-leftfade');
				productSlider.parentElement.querySelector('.slide-right').classList.remove('-visible');
				productSlider.parentElement.querySelector('.slide-left').classList.remove('-visible');
			} else if (customisationSlider2.isEnd) {
				productSlider.classList.remove('-rightfade');
				productSlider.classList.add('-leftfade');
				productSlider.parentElement.querySelector('.slide-right').classList.remove('-visible');
				productSlider.parentElement.querySelector('.slide-left').classList.add('-visible');
			} else if (customisationSlider2.isBeginning) {
				productSlider.classList.remove('-leftfade');
				productSlider.classList.add('-rightfade');
				productSlider.parentElement.querySelector('.slide-left').classList.remove('-visible');
				productSlider.parentElement.querySelector('.slide-right').classList.add('-visible');
			} else {
				productSlider.classList.add('-leftfade', '-rightfade');
				productSlider.parentElement.querySelector('.slide-right').classList.add('-visible');
				productSlider.parentElement.querySelector('.slide-left').classList.add('-visible');
			}
		});
	}

}